document.addEventListener("DOMContentLoaded", () => {
  const $slider = $(".mobile-product-images");
  const totalSlides = $slider.children().length;

  if (totalSlides === 0) return;

  // Create custom navigation container with correct order: prev, counter, next
  const navContainer = $('<div class="mobile-product-images-nav"></div>');
  const prevArrow = $(
    '<button type="button" class="slick-prev mobile-product-images-prev" aria-label="Previous image">' +
      "</button>",
  );
  const counter = $(
    '<span class="mobile-product-images-counter">1 / ' +
      totalSlides +
      "</span>",
  );
  const nextArrow = $(
    '<button type="button" class="slick-next mobile-product-images-next" aria-label="Next image">' +
      "</button>",
  );

  navContainer.append(prevArrow);
  navContainer.append(counter);
  navContainer.append(nextArrow);
  $slider.after(navContainer);

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    customPaging: function (slider, i) {
      return (
        '<img src="' + $(slider.slides[i]).find("img").attr("src") + '" />'
      );
    },
  });

  // Update counter on slide change
  $slider.on("afterChange", function (event, slick, currentSlide) {
    counter.text(currentSlide + 1 + " / " + totalSlides);
  });

  // Handle thumbnail clicks to scroll to corresponding main image
  const imageThumbs = document.querySelectorAll(".image-thumbs img");
  const imageMain = document.getElementById("mainImageScroll");

  if (imageThumbs.length > 0 && imageMain) {
    imageThumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const targetIndex = thumb.getAttribute("data-target");
        const targetImage = document.getElementById(`image-${targetIndex}`);

        if (targetImage) {
          targetImage.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
      });
    });
  }
});
